(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ia-popup"] && !Shopify.designMode) return;
  try {
    
/*
setTimeout(() => {
  const box = document.getElementById('btn-show-ia-popup');
  box.style.display = 'block';
}, 2000); 
*/
  
  document.getElementById("btn-show-ia-popup").onclick = function() {showModal()};
  document.getElementById("b_body_ia").onclick = function() {hideModal()};
  document.getElementById("p_close_ia").onclick = function() {hideModal()};


  

function showModal() {
  document.getElementById("intelligence-artificiel-popup").style.display = 'block';
}

  function hideModal() {
  document.getElementById("intelligence-artificiel-popup").style.display = 'none';
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-collection-description"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
	var maxLength = 300;

  $(".rte.collection__description p").each(function(){
	var myStr = $(this).text();
		if($.trim(myStr).length > maxLength){
			var newStr = myStr.substring(0, maxLength);
			var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
			$(this).empty().html(newStr);
			$(this).append(' <a href="javascript:void(0);" class="read-more">'+$(".metafields-div").data("read-more")+'...</a>');
			$(this).append('<span class="more-text">' + removedStr + '</span>');
		}
	});
  
	$(".metafield-rich_text_field p").each(function(){
		var myStr = $(this).text();
		if($.trim(myStr).length > maxLength){
			var newStr = myStr.substring(0, maxLength);
			var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
			$(this).empty().html(newStr);
			$(this).append(' <a href="javascript:void(0);" class="read-more">'+$(".metafields-div").data("read-more")+'...</a>');
			$(this).append('<span class="more-text">' + removedStr + '</span>');
		}
	});
	$(".read-more").click(function(){
		$(this).siblings(".more-text").contents().unwrap();
		$(this).remove();
	});
});

  } catch(e) { console.error(e); }
})();
})();
